import React, { useState } from "react";
import { emailValidation, notEmptyValidation, urlValidation } from "../../../functions/validation";

const InputArea = (props) => {
  const { placeholder, label, rows, value, onChange, name, className, validation, errorText } = props;

  const [error, seterror] = useState(null);

  function checkValidation() {
    if (validation === "ne") {
      !notEmptyValidation(value) && seterror(errorText ? errorText : "Required Input");
    } else if (validation === "email") {
      !emailValidation(value) && seterror(errorText ? errorText : "Invalid E-mail Address");
    } else if (validation === "url") {
      !urlValidation(value) && seterror(errorText ? errorText : "Invalid URL");
    } else {
      seterror(null);
    }
  }
  return (
    <div className={`input-area ${error ? "input-error" : ""} ${className}`}>
      <p className="label">{error ? error : label ? label : placeholder}</p>
      <textarea
        type="text"
        placeholder={placeholder}
        rows={rows ? rows : 6}
        value={value}
        onChange={(e) => {
          seterror(null);
          onChange(e);
        }}
        name={name}
        onBlur={checkValidation}
      />
    </div>
  );
};

export default InputArea;
